import React, { Component } from 'react';

class IconStatusCheck extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                fill="none"
                viewBox="0 0 17 16"
            >
                <path
                    fill="#1AB51E"
                    fillRule="evenodd"
                    d="M16.979 8a8 8 0 11-16 0 8 8 0 0116 0zm-8.926 4.236l5.936-5.935a.516.516 0 000-.73l-.73-.73a.516.516 0 00-.73 0l-4.84 4.84-2.26-2.26a.516.516 0 00-.73 0l-.73.73a.516.516 0 000 .73l3.354 3.355a.516.516 0 00.73 0z"
                    clipRule="evenodd"
                ></path>
            </svg>
        );
    }
}

export default IconStatusCheck;